import { useNavigate, useSearch } from '@tanstack/react-router';

import {
  domainsRouteSearchSchema,
  parsePublisherDomainsRouteSearch,
  serializePublisherDomainsRouteSearch,
} from './domainsRouteSearch';
import type { PublisherDomainStatus } from './model';

export function usePublisherDomainsRouteFilters() {
  const navigate = useNavigate({ from: '/supply/publishers/$publisherId/details/domains' });
  const search = useSearch({ strict: false });
  const filter = parsePublisherDomainsRouteSearch(domainsRouteSearchSchema(search));
  const update = (next: typeof filter) => {
    void navigate({ search: serializePublisherDomainsRouteSearch(next), replace: true });
  };
  return {
    filter,
    setSearch: (searchTerm: string) => {
      update({ ...filter, searchTerm, page: 0 });
    },
    setStatuses: (statuses: PublisherDomainStatus[]) => {
      update({ ...filter, statuses, page: 0 });
    },
    setPagination: (page: number, size: number) => {
      update({ ...filter, page: size === filter.size ? page : 0, size });
    },
  };
}
